import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import * as XLSX from "xlsx";
import { TextField } from "@material-ui/core";
import { Alert, Snackbar } from "@mui/material";
import ProductPurchaseService from "../../services/ProductPurchaseService";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../components/layouts/WithLoader";

const AjouterAchats = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState([]);
  const [allWarehouses, setAllWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [purchaseDate, setPurchaseDate] = useState("");
  const [file, setFile] = useState(null);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  useEffect(() => {
    if (localStorage.getItem("status") === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
  }, []);

  useEffect(() => {
    if (!userRole.includes("ADMIN")) {
      return;
    }
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setAllWarehouses(
            response.data.success.map((element) => ({
              value: element.id,
              label: element.name,
            }))
          );
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, [userRole]);

  const showError = (text) => {
    setErrorAlertText(text);
    setOpenErrorAlert(true);
  };

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onDownloadModelHandler = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["barcode", "quantity", "buying price"],
    ]);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Achats");
    XLSX.writeFile(workbook, "model_achats.xlsx");
  };

  const onChangeFile = (event) => {
    const selected = event.target.files[0];
    if (selected && !selected.name.toLowerCase().endsWith(".xlsx")) {
      showError("Erreur : seuls les fichiers .xlsx sont acceptés");
      setFile(null);
      setFileInputKey((key) => key + 1);
      return;
    }
    setFile(selected || null);
  };

  const onSubmitHandler = () => {
    if (!selectedWarehouse) {
      showError("Erreur : veuillez choisir un dépôt");
      return;
    }
    if (!purchaseDate) {
      showError("Erreur : veuillez choisir la date d'achat");
      return;
    }
    if (!file) {
      showError("Erreur : veuillez choisir un fichier .xlsx");
      return;
    }

    setIsUploading(true);
    setResult(null);
    startLoading();
    ProductPurchaseService.importProductPurchasesWarehouse(
      getCurrentUserId(),
      selectedWarehouse.value,
      purchaseDate + "T00:00:00",
      file
    )
      .then((response) => {
        if (response.data.error) {
          showError("Erreur : " + response.data.error);
          return;
        }
        setResult({
          success: response.data.success ?? 0,
          notAdded: response.data.notAdded || [],
        });
        setFile(null);
        setFileInputKey((key) => key + 1);
      })
      .catch((e) => {
        showError("Erreur : " + (e.response?.data?.error || e));
      })
      .finally(() => {
        setIsUploading(false);
        stopLoading();
      });
  };

  if (!userRole.includes("ADMIN")) {
    return (
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <section className="content-header">
          <div className="container-fluid">
            <p>Accès réservé aux administrateurs.</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/prixAchat" style={{ color: "black" }}>
                    Prix d'achat
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Ajouter des achats
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Ajouter des achats</h3>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <p className="mb-0">
                      Fichier .xlsx, première feuille uniquement. La première
                      ligne (en-tête) est ignorée. Colonnes : A = code à barre,
                      B = quantité, C = prix d'achat.
                    </p>
                    <button
                      className="btn btn-dark"
                      onClick={onDownloadModelHandler}
                    >
                      <i className="fas fa-download"></i> Télécharger le modèle
                    </button>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Dépôt</label>
                        <Select
                          value={selectedWarehouse}
                          onChange={setSelectedWarehouse}
                          options={allWarehouses}
                          placeholder="Choisir le dépôt"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date d'achat</label>
                        <TextField
                          style={{ width: "100%" }}
                          variant="outlined"
                          type="date"
                          size="small"
                          value={purchaseDate}
                          onChange={(e) => setPurchaseDate(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Fichier Excel</label>
                        <input
                          key={fileInputKey}
                          style={{
                            border: "1px solid hsl(0, 0%, 80%)",
                            width: "100%",
                          }}
                          type="file"
                          accept=".xlsx"
                          className="btn"
                          onChange={onChangeFile}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-outline-dark mx-1"
                      onClick={() => navigate("/prixAchat")}
                    >
                      Retour
                    </button>
                    <button
                      className="btn btn-dark mx-1"
                      onClick={onSubmitHandler}
                      disabled={isUploading}
                    >
                      <i className="fas fa-location-arrow"></i>{" "}
                      {isUploading ? "Envoi en cours..." : "Ajouter les achats"}
                    </button>
                  </div>
                </div>
              </div>

              {result && (
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Résultat de l'import</h3>
                  </div>
                  <div className="card-body">
                    <p>
                      <span className="badge bg-success mr-2">
                        {result.success}
                      </span>
                      ligne(s) ajoutée(s)
                      {result.notAdded.length > 0 && (
                        <>
                          {" — "}
                          <span className="badge bg-danger mr-2">
                            {result.notAdded.length}
                          </span>
                          ligne(s) non ajoutée(s)
                        </>
                      )}
                    </p>
                    {result.notAdded.length > 0 && (
                      <table className="table table-striped table-sm">
                        <thead>
                          <tr>
                            <th>Ligne Excel</th>
                            <th>Code à barre</th>
                            <th>Raison</th>
                          </tr>
                        </thead>
                        <tbody>
                          {result.notAdded.map((item, i) => (
                            <tr key={i}>
                              <td>{item.row}</td>
                              <td>{item.barcode}</td>
                              <td>{item.reason}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleErrorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleErrorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default withLoader(AjouterAchats);
